module.exports = __webpack_public_path__ + "img/CamperTrader_005155.4ef65bf9.webp";